import { useState } from "react";
import { Alert, Container, Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../i18n/i18n.constants";
import { ListItem } from "../../../app/models/components/listItem";
import { isNotFoundStatus } from "../../../services/api/statusManagers";
import { ErrorResponse } from "../../../app/models/api/errorResponse";
import { useGetUserProfileQuery } from "../../../app/api/userApi";
import { useGetUserInvoicesQuery } from "../../../app/api/invoicesApi";
import UserProfileForm from "../../../features/userProfile/userProfileForm/UserProfileForm";
import MyCompanies from "../myCompanies/MyCompanies";
import Invoices from "../invoices/Invoices";

const UserProfile = () => {
    const { t } = useTranslation(namespaces.userAdminPanel);
    const { data: userProfileData, isLoading: isProfileLoading, error: profileError } = useGetUserProfileQuery();

    const items = [
        { id: "profile", label: t("userProfile.menu.profile") },
        { id: "companies", label: t("userProfile.menu.companies") },
        { id: "invoices", label: t("userProfile.menu.invoices") },
    ] as ListItem[];

    const [activeTabKey, setActiveTabKey] = useState(items[0].id);

    const { data: invoices, isLoading: invoicesLoading } = useGetUserInvoicesQuery(undefined, {
        skip: activeTabKey !== "invoices",
    });

    return (
        <Container className="my-profile mt-4">
            <h1>{t("userProfile.title")}</h1>

            {isNotFoundStatus(profileError) ? (
                <Alert variant="danger" className="mt-3 text-start">
                    <p className="m-0">{(profileError as ErrorResponse).data.detail}</p>
                </Alert>
            ) : (
                <Tabs
                    activeKey={activeTabKey}
                    onSelect={(k) => setActiveTabKey(k ?? items[0].id)}
                    className="mb-3 mt-4"
                >
                    {items.map((item) => (
                        <Tab eventKey={item.id} title={item.label} key={item.id}>
                            {item.id === "profile" && (
                                <div className="p-4 bg-white mt-3">
                                    <UserProfileForm isLoading={isProfileLoading} userProfileData={userProfileData} />
                                </div>
                            )}
                            {item.id === "companies" && (
                                <MyCompanies />
                            )}
                            {item.id === "invoices" && (
                                <Invoices data={invoices} isLoading={invoicesLoading} />
                            )}
                        </Tab>
                    ))}
                </Tabs>
            )}
        </Container>
    );
};

export default UserProfile;
